<template>
  <div>
    <CRow class="justify-content-between mb-3">
      <CCol sm="auto"
        ><div class="ui-type-display-lg" v-if="!familyNameEditMode">
          {{ this.$store.state.connections.current.family.name }}
          <a @click="editFamilyName()" href="#" class="ml-2 text-primary">
            <font-awesome-icon icon="edit" class="" />
          </a>
        </div>
        <div v-else class="d-flex flex-row align-items-center">
          <CInput
            v-model="currentFamilyName"
            class="mb-0"
            id="family-name-input"
          />
          <CButton class="ml-2" color="primary" @click="saveFamilyName()">
            {{ $t("common.editor.button.save") }}
          </CButton>
          <CButton
            variant="outline"
            class="ml-2"
            color="primary"
            @click="cancelEditFamilyName()"
          >
            {{ $t("common.editor.button.cancel") }}
          </CButton>
        </div>

        <CRow v-if="error">
          <span class="text-danger block w-100 mt-1 ml-2 px-2 py-1">
            {{ error }}
          </span>
        </CRow>
      </CCol>
      <CCol sm="auto">
        <CButtonGroup class="mx-auto">
          <CInput
            horizontal
            v-model="search"
            :placeholder="$t('role.profile.tab_images.search_placeholder')"
          >
            <template #append-content><CIcon name="cil-filter" /> </template>
          </CInput>
        </CButtonGroup>
        <CButton color="primary" @click="onInviteMember()" class="mb-3">
          {{ $t("family.settings.members.btn_add") }}
        </CButton>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="auto">
        <p>
          {{
            $t("family.settings.members.intro", [
              this.$store.state.connections.current.family.name,
            ])
          }}
        </p></CCol
      >
    </CRow>

    <CRow class="justify-content-start mb-3" v-if="!loading">
      <CCol
        sm="12"
        md="6"
        xl="4"
        v-for="(item, index) in filteredUsers"
        :key="index"
      >
        <CCard>
          <CCardBody>
            <div
              class="
                d-flex
                flex-row
                w-100
                justify-content-between
                align-items-center
                mb-3
              "
            >
              <div
                class="d-flex flex-row justify-content-start align-items-center"
              >
                <div
                  style="height: 35px; width: 35px"
                  class="
                    rounded-circle
                    bg-gray-100
                    text-center text-primary
                    d-flex
                    justify-content-center
                    align-items-center
                    font-weight-bold
                  "
                >
                  {{
                    item.user.first_name.substring(0, 1).toUpperCase() +
                    item.user.last_name.substring(0, 1).toUpperCase()
                  }}
                </div>
                <h4 class="m-0 ml-2">
                  {{ item.user.first_name }} {{ item.user.last_name }}
                </h4>
                <span
                  v-if="item.user.invite_pending"
                  class="badge badge-warning ml-2"
                  >{{ $t("family.settings.members.invited") }}</span
                >
              </div>

              <a
                v-if="filteredUsers.length > 1"
                @click="handleRemoveMember($event, item)"
                href="#"
                class="ml-2 text-primary"
              >
                <font-awesome-icon :icon="['far', 'trash-alt']" />
              </a>
            </div>

            <table class="table">
              <tbody>
                <tr>
                  <td class="py-2 px-0 align-middle border-0">
                    {{ $t("models.email.email") }}
                  </td>
                  <td class="py-2 px-0 text-right border-0">
                    {{ item.user.email }}
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-0 align-middle">
                    {{ $t("family.settings.members.permissions.data") }}
                  </td>
                  <td class="py-2 px-0">
                    <CDropdown
                      class="d-flex justify-content-end"
                      color="gray-100"
                      size="sm"
                      :togglerText="permissionLabels[item.permissions.role_dc]"
                    >
                      <CDropdownItem
                        v-for="(val, key) in permissionLabels"
                        :key="key"
                        @click="handlePermissionChange(item, 'role_dc', key)"
                        >{{ val }}</CDropdownItem
                      >
                    </CDropdown>
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-0 align-middle">
                    {{ $t("family.settings.members.permissions.products") }}
                  </td>
                  <td class="py-2 px-0">
                    <CDropdown
                      class="d-flex justify-content-end"
                      color="gray-100"
                      size="sm"
                      :togglerText="permissionLabels[item.permissions.role_pp]"
                    >
                      <CDropdownItem
                        v-for="(val, key) in permissionLabels"
                        :key="key"
                        @click="handlePermissionChange(item, 'role_pp', key)"
                        >{{ val }}</CDropdownItem
                      >
                    </CDropdown>
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-0 align-middle">
                    {{ $t("family.settings.members.permissions.logistics") }}
                  </td>
                  <td class="py-2 px-0">
                    <CDropdown
                      class="d-flex justify-content-end"
                      color="gray-100"
                      size="sm"
                      :togglerText="permissionLabels[item.permissions.role_lg]"
                    >
                      <CDropdownItem
                        v-for="(val, key) in permissionLabels"
                        :key="key"
                        @click="handlePermissionChange(item, 'role_lg', key)"
                        >{{ val }}</CDropdownItem
                      >
                    </CDropdown>
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-0 align-middle">
                    {{ $t("family.settings.members.permissions.orders") }}
                  </td>
                  <td class="py-2 px-0">
                    <CDropdown
                      class="d-flex justify-content-end"
                      color="gray-100"
                      size="sm"
                      :togglerText="permissionLabels[item.permissions.role_os]"
                    >
                      <CDropdownItem
                        v-for="(val, key) in permissionLabels"
                        :key="key"
                        @click="handlePermissionChange(item, 'role_os', key)"
                        >{{ val }}</CDropdownItem
                      >
                    </CDropdown>
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-0 align-middle">
                    {{ $t("family.settings.members.permissions.finances") }}
                  </td>
                  <td class="py-2 px-0">
                    <CDropdown
                      class="d-flex justify-content-end"
                      color="gray-100"
                      size="sm"
                      :togglerText="permissionLabels[item.permissions.role_fin]"
                    >
                      <CDropdownItem
                        v-for="(val, key) in permissionLabels"
                        :key="key"
                        @click="handlePermissionChange(item, 'role_fin', key)"
                        >{{ val }}</CDropdownItem
                      >
                    </CDropdown>
                  </td>
                </tr>
                <tr>
                  <td class="py-2 px-0 align-middle">
                    {{ $t("family.settings.members.permissions.exports") }}
                  </td>
                  <td class="py-2 px-0">
                    <CDropdown
                      class="d-flex justify-content-end"
                      color="gray-100"
                      size="sm"
                      :togglerText="permissionLabels[item.permissions.role_exp]"
                    >
                      <CDropdownItem
                        v-for="(val, key) in permissionLabels"
                        :key="key"
                        @click="handlePermissionChange(item, 'role_exp', key)"
                        >{{ val }}</CDropdownItem
                      >
                    </CDropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow class="justify-content-start mb-3" v-if="loading">
      <CCol sm="3">
        <CSpinner color="primary" />
      </CCol>
    </CRow>

    <CModal :show="modal.show" :closeOnBackdrop="false" :centered="true">
      <template #header>
        <h5 class="modal-title">
          {{ $t("family.settings.members.btn_add") }}
        </h5>
      </template>

      <CAlert v-if="modal.error.hasGeneralErrors()" color="danger" class="mb-3">
        {{ modal.error.general().join(" ") }}
      </CAlert>

      <form action="" @submit.prevent="inviteMember">
        <CInput
          v-model="modal.form.name"
          :label="$t('models.user.name')"
          :description="$t('models.user.name_info')"
          type="text"
          :isValid="modal.error.isValidField('name')"
          :invalidFeedback="modal.error.fieldError('name')"
          required
        />
        <CInput
          v-model="modal.form.surname"
          :label="$t('models.user.surnname')"
          :description="$t('models.user.surnname_info')"
          type="text"
          :isValid="modal.error.isValidField('surname')"
          :invalidFeedback="modal.error.fieldError('surname')"
          required
        />
        <CInput
          v-model="modal.form.email"
          :label="$t('models.user.defaultmail')"
          type="email"
          :isValid="modal.error.isValidField('email')"
          :invalidFeedback="modal.error.fieldError('email')"
          required
        />
      </form>

      <template #footer>
        <CButton
          color="primary"
          variant="outline"
          @click.prevent="closeModal"
          >{{ $t("producer.products.availabilityEdit.btnCancel") }}</CButton
        >
        <vue-ladda
          :loading="modal.loading"
          data-style="zoom-in"
          button-class="btn btn-primary px-4"
          @click.prevent="inviteMember"
          >{{ $t("family.settings.members.modal.confirm") }}</vue-ladda
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import errorResponse from "../../../helpers/error";
import { apiGet, apiPatch, apiPost } from "../../../helpers/apiHelper";
import get from "lodash/get";

export default {
  name: "Members",

  data() {
    return {
      loading: true,
      search: "",
      familyData: [],
      permissionLabels: {
        0: this.$t("models.fyc.permissions.options.v_0"),
        1: this.$t("models.fyc.permissions.options.v_1"),
        2: this.$t("models.fyc.permissions.options.v_2"),
      },
      familyNameEditMode: false,
      currentFamilyName: this.$store.state.connections.current.family.name,
      modal: {
        show: false,
        loading: false,
        error: errorResponse(),
        form: {
          name: "",
          surname: "",
          email: "",
        },
      },
      error: null,
    };
  },

  computed: {
    permissionsData() {
      return new DataManager([
        { value: 0, label: this.$t("models.fyc.permissions.options.v_0") },
        { value: 1, label: this.$t("models.fyc.permissions.options.v_1") },
        { value: 2, label: this.$t("models.fyc.permissions.options.v_2") },
      ]);
    },
    filteredUsers() {
      if (!this.search) return this.familyData;

      const searchTerm = this.search.toLowerCase();

      return this.familyData.filter((item) => {
        const { first_name, last_name, email } = item.user;

        return (
          first_name.toLowerCase().includes(searchTerm) ||
          last_name.toLowerCase().includes(searchTerm) ||
          email.toLowerCase().includes(searchTerm)
        );
      });
    },
  },

  methods: {
    async handlePermissionChange(item, permissionKey, permissionValue) {
      item.permissions[permissionKey] = parseInt(permissionValue);

      const response = await apiPatch("auth_family_connection", item.id, item, [
        this.$store.state.connections.current.family.id,
      ]);
      if (response && response.status === 200) {
        this.$store.dispatch("connections/currentRefresh");
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("family.settings.permissionsUpdated"),
          color: "success",
          autohide: true,
        });
      } else {
        console.error("Unexpected response:", response);
        this.$store.dispatch("toaster/add", {
          title: "Error!",
          text: "Encountered an error",
          color: "error",
          autohide: true,
        });
      }
    },

    async handleRemoveMember(event, item) {
      event.preventDefault();
      item.is_active = false;

      const response = await apiPatch("auth_family_connection", item.id, item, [
        this.$store.state.connections.current.family.id,
      ]);
      if (response && response.status === 200) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("family.settings.members.removedSuccessMsg"),
          color: "success",
          autohide: true,
        });
        await this.fetchData([this.$store.state.connections.current.family.id]);
      } else {
        console.error("Unexpected response:", response);
        this.$store.dispatch("toaster/add", {
          title: "Error!",
          text: "Encountered an error",
          color: "error",
          autohide: true,
        });
      }
    },

    onInviteMember() {
      this.modal.error.reset();
      this.modal.form = {
        name: "",
        surname: "",
        email: "",
      };
      this.modal.show = true;
    },

    closeModal() {
      this.modal.show = false;
    },

    async inviteMember() {
      const requestParams = {
        name: this.modal.form.name,
        surname: this.modal.form.surname,
        email: this.modal.form.email,
      };
      this.modal.error.reset();

      const response = await apiPost("auth_family_connection", requestParams, [
        this.$store.state.connections.current.family.id,
      ]);
      if (response && response.status === 201) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("family.settings.members.invitedSuccessMsg"),
          color: "success",
          autohide: true,
        });
        this.modal.show = false;
        await this.fetchData([this.$store.state.connections.current.family.id]);
      } else {
        console.error("Unexpected response:", response);
        this.$store.dispatch("toaster/add", {
          title: "Error!",
          text: "Encountered an error",
          color: "error",
          autohide: true,
        });
      }
    },

    async fetchData(familyId) {
      const response = await apiGet("auth_family_connection", familyId);
      if (response && response.data) {
        this.loading = false;
        this.familyData = response.data.payload.Items;
      }
    },

    editFamilyName() {
      this.familyNameEditMode = true;
      this.$nextTick(() => {
        const input = document.getElementById("family-name-input");
        if (input) {
          input.focus();
        }
      });
    },

    async saveFamilyName() {
      const perm = get(
        this.$store,
        "state.connections.current.permissions.role_dc"
      );
      const id = get(this.$store, "state.connections.current.family.id");

      if (perm !== 2) {
        this.error = this.$t("common.general.permissionError");
        return;
      }

      const requestParams = {
        id: id,
        name: this.currentFamilyName,
      };
      this.error = null;

      const response = await apiPatch("auth_family", id, requestParams, []);

      if (response && response.status === 200) {
        this.$store.dispatch("connections/currentRefresh");

        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("user.profile.data.ok.message"),
          color: "success",
          autohide: true,
        });

        this.error = null;
        this.familyNameEditMode = false;
      } else {
        this.error = response.errors.fields.name[0] || "Encountered an error";
        console.error("Unexpected response:", response);
        this.$store.dispatch("toaster/add", {
          title: "Error!",
          text: "Encountered an error",
          color: "error",
          autohide: true,
        });
      }
    },

    cancelEditFamilyName() {
      this.familyNameEditMode = false;
      this.currentFamilyName =
        this.$store.state.connections.current.family.name;
      this.error = null;
    },
  },
  async created() {
    this.loading = true;
    await this.fetchData([this.$store.state.connections.current.family.id]);
  },
};
</script>
